import { REST_API_URL } from "../../api/config";
import { getAccessToken } from "./authRouting";
import { buildHeaders } from "../../api/buildHeaders";

const API_URL = REST_API_URL;

export async function checkOnboardingStatus(token) {
  try {
    const res = await fetch(`${API_URL}/auth/onboarding-pass-check/`, {
      method: "GET",
      headers: buildHeaders(),
    });

    if (res.status === 200) {
      return "COMPLETED";
    }

    if (res.status === 400) {
      const err = await res.json().catch(() => ({}));

      const rawStatus =
        err?.status ?? err?.code ?? err?.onboarding_code ?? null;

      const code = parseInt(
        Array.isArray(rawStatus) ? rawStatus[0] : rawStatus,
        10,
      );

      return Number.isFinite(code) ? code : null;
    }

    if (res.status === 401) {
      return null;
    }

    console.error("Unexpected onboarding-pass-check status:", res.status);
    return null;
  } catch (error) {
    console.error("checkOnboardingStatus failed:", error);
    return null;
  }
}

export async function resolveAuthState() {
  const token = getAccessToken();

  if (!token) {
    return {
      isAuthenticated: false,
      onboardingStatus: null,
    };
  }

  const onboardingStatus = await checkOnboardingStatus(token);

  if (onboardingStatus === null) {
    return {
      isAuthenticated: false,
      onboardingStatus: null,
    };
  }

  return {
    isAuthenticated: true,
    onboardingStatus,
  };
}
